import { formatDistanceStrict } from 'date-fns';
/**
 * Returns formatted time difference string from the moment of NOW and a passed date.
 *
 * @param date
 * @param unit
 * @returns
 */
var getTimeDifference = function getTimeDifference(date) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
  return formatDistanceStrict(new Date(), date, {
    unit: unit
  });
};
export default getTimeDifference;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/getTimeDifference.js
// module id = 2852
// module chunks = 11